/**
 * De koers, op EEN plek voor server en browser samen.
 *
 * Waarom hier en niet in de server: de browser moet dezelfde omrekening doen
 * als de server, anders staan er twee bedragen op het scherm die allebei
 * kloppen volgens hun eigen rekensom. In het oude concept stond de koers op zes
 * plaatsen; daarna is hij naar de server gegaan en alsnog teruggeslopen in een
 * component, als een kale 0.92 midden in de opmaak.
 *
 * Kosten worden in DOLLAR opgeslagen en pas bij het tonen omgerekend.
 * Verandert de koers, dan klopt de historie nog steeds.
 */
export const USD_NAAR_EUR = 0.92;

export function naarEur(usd: number): number {
  return usd * USD_NAAR_EUR;
}
